import { useMediaQuery } from '@/components/hooks/useMediaQuery';

import { useFreezeSelection } from '../contexts';
import { MOBILE_BREAKPOINT } from '../utils/constants';

export const FreezeStatusBar = () => {
  const { fertilizationIds, liveEmbryoIds, tempEmbryoIds, totalSelected } =
    useFreezeSelection();
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  if (isMobile) {
    return (
      <div className="flex flex-wrap items-center gap-x-2 text-xs text-gray-500">
        <span className="font-semibold text-gray-700">{totalSelected} sel</span>
        {totalSelected > 0 && (
          <span>
            {tempEmbryoIds.length}T · {liveEmbryoIds.length}L ·{' '}
            {fertilizationIds.length}F
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 text-xs text-gray-500">
      <span className="font-medium">
        <span className="text-gray-700">{totalSelected}</span> selected
      </span>
      {totalSelected > 0 && (
        <span>
          ({tempEmbryoIds.length} temp, {liveEmbryoIds.length} live,{' '}
          {fertilizationIds.length} mating
          {fertilizationIds.length !== 1 ? 's' : ''})
        </span>
      )}
      <span className="mx-1 h-3 w-px bg-gray-300" />
      <span className="flex items-center gap-1">
        <span className="inline-block size-2 rounded-full bg-green-500" /> OK
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block size-2 rounded-full bg-yellow-500" /> Warn
      </span>
      <span className="flex items-center gap-1">
        <span className="inline-block size-2 rounded-full bg-red-500" /> Err
      </span>
    </div>
  );
};
